<template>
  <div class="booking-detail-container">
    <h2>预订详情</h2>
    <el-card shadow="hover">
      <el-descriptions title="基本信息" :column="2">
        <el-descriptions-item label="ID">{{ bookingDetail.id }}</el-descriptions-item>
        <el-descriptions-item label="预订号">{{ bookingDetail.booking_no }}</el-descriptions-item>
        <el-descriptions-item label="用户ID">{{ bookingDetail.user_id }}</el-descriptions-item>
        <el-descriptions-item label="用户名称">{{ bookingDetail.user?.name || '未知' }}</el-descriptions-item>
        <el-descriptions-item label="房间ID">{{ bookingDetail.room_id }}</el-descriptions-item>
        <el-descriptions-item label="房间号">{{ bookingDetail.room?.room_number || '未知' }}</el-descriptions-item>
        <el-descriptions-item label="状态">{{ getStatusName(bookingDetail.status) }}</el-descriptions-item>
        <el-descriptions-item label="总金额">¥{{ bookingDetail.total_amount }}</el-descriptions-item>
        <el-descriptions-item label="入住日期">{{ formatDate(bookingDetail.check_in_date) }}</el-descriptions-item>
        <el-descriptions-item label="退房日期">{{ formatDate(bookingDetail.check_out_date) }}</el-descriptions-item>
        <el-descriptions-item label="客人姓名">{{ bookingDetail.guest_name }}</el-descriptions-item>
        <el-descriptions-item label="客人电话">{{ bookingDetail.guest_phone }}</el-descriptions-item>
        <el-descriptions-item label="入住人数">{{ bookingDetail.adult_count }}成人 + {{ bookingDetail.child_count }}儿童</el-descriptions-item>
        <el-descriptions-item label="是否含早餐">{{ bookingDetail.breakfast_included ? '是' : '否' }}</el-descriptions-item>
        <el-descriptions-item label="特殊要求" :span="2">{{ bookingDetail.special_requests || '-' }}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ formatDate(bookingDetail.created_at) }}</el-descriptions-item>
        <el-descriptions-item label="更新时间">{{ formatDate(bookingDetail.updated_at) }}</el-descriptions-item>
      </el-descriptions>
      
      <div class="detail-actions">
        <el-button @click="handleBack">返回</el-button>
        <el-button type="primary" @click="handleEdit">编辑</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { ElMessage } from 'element-plus';
import request from '../../api/axios';

export default {
  name: 'BookingDetail',
  setup() {
    const router = useRouter();
    const route = useRoute();
    const bookingId = route.params.id;
    
    const bookingDetail = ref({
      id: '',
      user_id: '',
      room_id: '',
      booking_no: '',
      status: '',
      check_in_date: '',
      check_out_date: '',
      total_amount: 0,
      guest_name: '',
      guest_phone: '',
      adult_count: 0,
      child_count: 0,
      breakfast_included: false,
      special_requests: '',
      created_at: '',
      updated_at: ''
    });
    
    // 获取预订详情
    const fetchBookingDetail = async () => {
      try {
        const response = await request({
          url: `/manage/bookings/${bookingId}`,
          method: 'get'
        });
        bookingDetail.value = response.data;
      } catch (error) {
        ElMessage.error('获取预订详情失败');
        console.error(error);
        router.push('/bookings/list');
      }
    };
    
    // 页面加载时获取预订详情
    onMounted(() => {
      fetchBookingDetail();
    });
    
    // 获取状态名称
    const getStatusName = (status) => {
      const statusMap = {
        'pending': '待确认',
        'confirmed': '已确认',
        'checked_in': '已入住',
        'cancelled': '已取消',
        'completed': '已完成'
      };
      return statusMap[status] || status;
    };
    
    // 格式化日期
    const formatDate = (dateStr) => {
      if (!dateStr) return '-';
      const date = new Date(dateStr);
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });
    };
    
    // 返回列表页面
    const handleBack = () => {
      router.push('/bookings/list');
    };
    
    // 跳转到编辑页面
    const handleEdit = () => {
      router.push(`/bookings/edit/${bookingId}`);
    };
    
    return {
      bookingDetail,
      getStatusName,
      formatDate,
      handleBack,
      handleEdit
    };
  }
};
</script>

<style scoped>
.booking-detail-container {
  padding: 20px;
}

.booking-detail-container h2 {
  margin-bottom: 20px;
  color: #333;
}

.detail-actions {
  margin-top: 20px;
  display: flex;
  justify-content: flex-start;
}

.detail-actions .el-button {
  margin-right: 10px;
}
</style>